import type { CRelatedArticlesBlock } from '../components/organisms/c-related-articles'

/**
 * Which extra articles CRelatedArticles fills its row with: the latest of the
 * first picked article's type (testimonials by default), up to three in
 * total, excluding the picked ones and the current entry. Pure, so the server
 * can fetch the same list the component then renders and extends.
 */
export function relatedArticlesQuery(field: Array<CRelatedArticlesBlock> | null | undefined, excludeId?: number | null) {
  const content = field && field.length ? field[0] : null
  const type = content && content.articles?.length ? content.articles[0].typeHandle ?? 'testimonialPages' : 'testimonialPages'
  const limit = content ? 3 - (content.articles?.length ?? 0) : 0
  let exclude: Array<string | number>
  if (content && content.articles) {
    exclude = ['not', ...content.articles.map((item) => item.id ?? '')]
    if (excludeId) exclude.push(excludeId.toString())
  } else {
    exclude = ['not', 0]
  }
  return { type, limit, exclude }
}

/** Trending blog articles CArticleListing shows first, so the list below excludes them. */
export function articleListingExcludeIds(
  field: Array<{ trendingArticles?: Array<{ id?: string; typeHandle?: string }> }> | null | undefined
) {
  const content = field && field.length ? field[0] : null
  return (
    content?.trendingArticles
      ?.filter((article) => article.typeHandle === 'blog' || article.typeHandle === 'legacyBlog')
      .map((article) => article.id ?? '') ?? []
  )
}
